"use client";
import * as React from "react";

const HtmlEmbed = React.forwardRef(function HtmlEmbed(
  { tag = "div", className = "", content = "", value = "", ...props },
  ref
) {
  const html = content || value || "";
  return React.createElement(tag, {
    className: className + " w-embed",
    dangerouslySetInnerHTML: { __html: html },
    ...props,
    ref,
  });
});

export default HtmlEmbed;
